import { Controller } from "@hotwired/stimulus";
import "./component.scss";

export default class extends Controller {
  static targets = ["scrollItem", "navigation", "item"];
  static values = {
    activeClass: String
  }

  static DESKTOP_QUERY = "(min-width: 800px)";

  connect() {
    this.onFrameLoad = this.handleFrameLoad.bind(this);

    this.scrollToNavigationOnSinglePost();
    this.addEventListeners();
  }

  disconnect() {
    this.removeEventListeners();
  }

  addEventListeners() {
    document.addEventListener("turbo:frame-load", this.onFrameLoad);
  }

  removeEventListeners() {
    document.removeEventListener("turbo:frame-load", this.onFrameLoad);
  }

  handleFrameLoad(event) {
    if (
      event.target.id === "community_main" &&
      event.target.querySelector(".single-post-page") &&
      window.matchMedia(this.constructor.DESKTOP_QUERY).matches &&
      this.hasNavigationTarget
    ) {
      requestAnimationFrame(() => this.scrollNavIntoView());
    }
  }

  scrollToNavigationOnSinglePost() {
    if (
      document.querySelector(".single-post-page") &&
      window.matchMedia(this.constructor.DESKTOP_QUERY).matches &&
      this.hasNavigationTarget
    ) {
      requestAnimationFrame(() => this.scrollNavIntoView());
    }
  }

  scrollNavIntoView() {
    const nav = this.navigationTarget.closest("nav");
    if (!nav) return;

    nav.style.scrollMarginTop = "16px";
    nav.scrollIntoView({ behavior: "instant", block: "start" });
    nav.style.scrollMarginTop = "";
  }

  scrollToActiveItem() {
    if (this.hasScrollItemTarget && this.hasNavigationTarget) {
      const nav = this.navigationTarget;
      const item = this.scrollItemTarget;
      const navRect = nav.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();

      nav.scrollLeft += itemRect.left - navRect.left - (navRect.width - itemRect.width) / 2;
    }
  }

  navigate(event) {
    const item = event.target
    this.itemTargets.forEach((el) => el.classList.remove("c-community_navigation-navigation-item--active"));
    item.classList.add("c-community_navigation-navigation-item--active");

    requestAnimationFrame(() => {
      item.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    });
  }
}
